import type { ComponentType, ReactNode } from "react";
import { Inbox } from "lucide-react";

import { cn } from "src/lib/utils";

interface EmptyStateProps {
	title: string;
	description?: ReactNode;
	icon?: ComponentType<{ className?: string }>;
	action?: ReactNode;
	className?: string;
}

/** Prototype `.empty-state` — every table and grid gets one of these, never a blank area. */
const EmptyState = ({ title, description, icon: Icon = Inbox, action, className }: EmptyStateProps) => (
	<div className={cn("tw-px-5 tw-py-12 tw-text-center", className)}>
		<Icon className="tw-mx-auto tw-mb-3 tw-h-10 tw-w-10 tw-text-teal" />
		<div className="tw-mb-1 tw-text-[14px] tw-font-bold tw-text-text">{title}</div>
		{description && <div className="tw-mx-auto tw-max-w-md tw-text-[13px] tw-text-text-soft">{description}</div>}
		{action && <div className="tw-mt-4 tw-flex tw-justify-center">{action}</div>}
	</div>
);

export default EmptyState;
